"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const tags_1 = require("../../atoms/tags");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const Tags = ({ tags, onRemove }) => {
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: tags.map((tag, i) => ((0, jsx_runtime_1.jsxs)(tags_1.Tag, { style: { cursor: "pointer" }, onClick: () => {
                onRemove(tag);
            }, variant: "silver", children: [tag.label, (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ["fas", "times-circle"] }, void 0)] }, i))) }, void 0));
};
const Wrapper = styled_components_1.default.div `
  & > span > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // text ellipsis requires values in px
    max-width: 200px;
  }
`;
exports.default = Tags;
//# sourceMappingURL=tags.js.map